export const DEFINITLY_LOST_THE_BATTLE = {
  min: Infinity,
  max: Infinity,
  avg: Infinity,
};
